export default __webpack_public_path__ + "static/media/webcam10.6b106e22.jfif";